import SuccessIconMessage from './SuccessIconMessage';

export default SuccessIconMessage;
